import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { exposeInitialWidgetLoadEvent } from '../../Helpers/events';

const InitialWidgetLoadEventManager = () => {
  const { iFrameId, widgetLabel, haveAllInitialMessagesArrived } = useSelector(
    (store) => store.optionalFormConfig
  );
  const {
    subcategoryName,
    subcategoryId,
    categoryName,
    sectorName,
    categoryId,
    tradingHubId,
    tradingHubName,
    submissionPageNumber,
    phoneNumberCountryCode,
  } = useSelector((store) => store.formConfig);
  const { visitorId } = useSelector((store) => store.userIdentities);
  const components = useSelector((store) => store.components);
  const { componentExperiments } = useSelector(
    (store) => store.experimentation
  );

  useEffect(() => {
    if (haveAllInitialMessagesArrived === true) {
      exposeInitialWidgetLoadEvent({
        currentPage: 0,
        components,
        iFrameId,
        widgetLabel,
        subcategoryName,
        subcategoryId,
        categoryName,
        categoryId,
        sectorName,
        tradingHubId,
        tradingHubName,
        visitorId,
        submissionPage: submissionPageNumber,
        phoneNumberCountryCode,
        componentExperiments,
      });
    }
  }, [haveAllInitialMessagesArrived]);

  return null;
};

export default InitialWidgetLoadEventManager;
